import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isCNPJ, isCPF } from 'validation-br';

export function criarRestituicaoForm(fb: FormBuilder): FormGroup {
  return fb.group({
    // ===== Dados do DAE =====
    nroDae: ['', Validators.required],
    valorGuia: [null, Validators.required],
    // "valorRestituir" é obrigatório apenas quando tipoRestituicao = 'P'
    valorRestituir: [null],
    tipoRestituicao: ['T', Validators.required],

    // ===== Motivo =====
    motivo: [null, Validators.required],
    exposicaoMotivo: ['', Validators.required],

    // ===== Dados do Requerente =====
    nomeRequerente: ['', Validators.required],
    cpfRequerente: ['', [Validators.required, cpfValidoValidator]],

    // ===== Titular da Conta (radio) =====
    titularConta: ['R', Validators.required],

    // ===== Dados bancários do titular/beneficiário =====
    tipoDocumentoConta: ['CPF', Validators.required],
    nomeTitularConta: ['', Validators.required],
    cpfCnpjTitularConta: ['', [Validators.required, cpfOuCnpjValidoValidator]],
    banco: [null, Validators.required],
    agencia: ['', Validators.required],
    dvAgencia: [''],
    contaCorrente: ['', Validators.required],
    dvContaCorrente: ['', Validators.required],

    // ===== Dados para contato =====
    nomeContato: ['', Validators.required],
    emailContato: ['', [Validators.required, Validators.email]],
    telefoneContato: ['', Validators.required]
  });
}

/**
 * Validador de CPF para campos que aceitam apenas CPF.
 */
export function cpfValidoValidator(control: AbstractControl) {
  const value = control.value;
  if (!value) {
    return null;
  }

  return isCPF(String(value)) ? null : { cpfInvalido: true };
}

/**
 * Validador para campo que pode ser CPF ou CNPJ.
 * Aqui, quando o valor tiver formato de CPF (11 dígitos), valida como CPF.
 * Caso contrário, apenas considera que a validação específica (ex.: CNPJ)
 * será tratada em outro ponto se necessário.
 */
export function cpfOuCnpjValidoValidator(control: AbstractControl) {
  const value = control.value;
  if (!value) {
    return null;
  }

  const parent = control.parent;
  const tipoDocumentoControl = parent ? parent.get('tipoDocumentoConta') : null;
  const tipoDocumentoConta = tipoDocumentoControl ? tipoDocumentoControl.value : null;

  if (tipoDocumentoConta === 'CNPJ') {
    const normalized = String(value || '').replace(/[^0-9a-zA-Z]/g, '');
    return isCNPJ(normalized) ? null : { cnpjInvalido: true };
  }

  return isCPF(String(value)) ? null : { cpfInvalido: true };
}
